export const environment = {
    apiUrl: 'https://nodeapi.stage.doc.inncircles.ai',
    prospectUrl: 'https://code.beta.inncirclesarena.com',
    ioSocketUrl: 'https://nodeapi.stage.doc.inncircles.ai',
    wsSocketUrl: 'wss://nodeapi.stage.doc.inncircles.ai/ws',
    s3Url: 'https://inncircles-ai-stage-public-0414.s3.us-east-2.amazonaws.com',
    jwtSecret: "inndoc_secret",
    onlyOfficeServer: "https://onlyoffice.stage.inncircles.ai",
    innDocAgentUrl: "https://test.chat.inncircles.ai",
    enableSubscription: true,
    loadTanStackDevTools: false,
    environment: 'stage'
};
